<script>
// Mixins
import spacingProps from '../mixins/spacing-props.js';

// Utils
import { getSlots } from '../utils/renderless-composition';
import { getSpacingClasses } from '../utils/spacing-class-utils';

export default {
    name: 'SpacingClass',
    functional: true,
    mixins: [spacingProps],
    render (createEl, context) {
        const spacingClasses = getSpacingClasses(context);
        return getSlots(createEl, context.children, spacingClasses);   
    }
}
</script>
